import { render, staticRenderFns } from "./GENIPictureView.vue?vue&type=template&id=3cd0672e&scoped=true&"
import script from "./GENIPictureView.vue?vue&type=script&lang=ts&"
export * from "./GENIPictureView.vue?vue&type=script&lang=ts&"
import style0 from "./GENIPictureView.vue?vue&type=style&index=0&id=3cd0672e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd0672e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDivider,VExpandTransition,VRow,VTextField})
